import { Route } from 'react-router-dom';
import { useQueryClient } from 'react-query';

import { RoutesInternal } from 'theSource/components';
import {
  BenefitsPageResponseDto,
  GET_BENEFITS_QUERY_KEY,
} from 'theSource/queries';
import { BenefitReviewPage } from './BenefitReviewPage';
import { BenefitsViewPage } from './BenefitsViewPage';
import { MyBenefits } from 'features';

interface BenefitsProps {
  lumosEnabled: boolean;
}

export const Benefits = ({lumosEnabled}: BenefitsProps) => {
  const queryClient = useQueryClient();
  const benefitsData: BenefitsPageResponseDto = queryClient.getQueryData(
    GET_BENEFITS_QUERY_KEY
  )!;

  return (
    <RoutesInternal>
      <Route path="/" element={
        lumosEnabled
          ? <MyBenefits />
          : <BenefitsViewPage data={benefitsData} />
        } 
      />
      <Route
        path=":benefitLookupCode"
        element={<BenefitReviewPage data={benefitsData} />}
      />
    </RoutesInternal>
  );
};
